import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TheCollision = () => {
    const sectionRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            const lines = textRef.current?.children;
            if (lines) {
                 gsap.fromTo(lines, 
                    { y: 100, opacity: 0, rotate: 2 },
                    { 
                        y: 0, 
                        opacity: 1, 
                        rotate: 0,
                        duration: 1.2, 
                        stagger: 0.1,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: sectionRef.current,
                            start: 'top 60%',
                            end: 'top 20%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }
        });
        return () => ctx.revert();
    }, []);

    return (
        <section ref={sectionRef} className="home-section home-section-hero-follow overflow-hidden">
            
            {/* Animated particle tracks  -  the "simulator" side */}
            
            <div className="max-w-6xl mx-auto relative z-10 before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/5 before:to-transparent before:blur-3xl before:-z-10">
                <div ref={textRef} className="max-w-4xl space-y-8 md:space-y-10">
                     <span className="home-kicker block">The Manifesto</span>
                     <h2 className="text-4xl md:text-6xl font-display font-bold text-white leading-tight">
                        The subject is not the problem.
                     </h2>
                     <h2 className="text-4xl md:text-6xl font-display font-bold text-white/80 leading-tight">
                        The order of introduction is.
                     </h2>
                     <p className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl leading-relaxed pt-4">
                        Particle physics is often experienced as mathematically dense, conceptually compressed, and difficult to visualize. Students meet the field through symbols like &beta;, &gamma;, dE/dx, and &theta;&#8320; long before they have any physical feeling for what those quantities mean.
                     </p>
                     <p className="text-xl md:text-2xl text-gray-400 font-light max-w-3xl leading-relaxed">
                        This project flips that order. It begins with interaction and observation  -  a beam, a detector, a visible response, and a question. Then it uses simulation, graphics, and guided prompts to build understanding from the ground up.
                     </p>
                </div>
            </div>
        </section>
    );
};

export default TheCollision;
